import { InjectionToken } from '@angular/core';

import { AdvertisersResponse } from '@rp/shared/models';
import { Observable } from 'rxjs';

export interface AdvertisersProvider {
  getAdvertisers(params?: string): Observable<AdvertisersResponse>;
}

export const ADVERTISERS_PROVIDER_TOKEN = new InjectionToken<AdvertisersProvider>(
  'AdvertisersProvider',
);
